
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[language]/emissions-map",
      function () {
        return require("private-next-pages/[language]/emissions-map/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[language]/emissions-map"])
      });
    }
  